import {useStatePair} from "../../../type/States";
import {PlacePresentationValueObject} from "../../../model/vo/content/place/PlacePresentationValueObject";
import {usePlaceUserStore} from "../../../stores/usePlaceUserStore";
import {getFormattedDateString} from "../../../utils/formatDate";
import {checkGuideVisible, setCurrentPage} from "../../../utils/ui/setCurrentPage";
import {
    configurePlaceErrorTypeAndSetErrorPage
} from "../../../utils/ui/configureErrorTypeAndSetErrorPage";
import {PlaceIO} from "../../../io/content/place/PlaceIO";
import React, {useEffect} from "react";
import {PlaceEventType} from "../../../constant/EventType";
import {PlacePathJointEventIO} from "../../../io/content/place/PlacePathJointEventIO";
import {Spinner} from "@fluentui/react-components";
import {ExhaustedPage} from "../common/ExhaustedPage";
import {ErrorPage} from "../common/ErrorPage";
import ParticipationCntFullPage from "../common/ParticipationCntFullPage";
import {ThresholdPage} from "../common/ThresholdPage";
import {PlacePathTypeColor, resolvePlacePathType} from "../../../constant/PlaceMissionType";
import Mission from '../../../components/mission/nshop_place/ver1/nplace_quiz/Mission'
import GuideLine from '../../../components/mission/nshop_place/common/GuideLine'
import {
    useCurrentPage, useCurrentPageUpdate,
    useGuideExpirationDate,
    useHiddenGuideList,
    useHiddenGuideListUpdate,
    useNextPage, useNextPageUpdate, usePrevPathType, usePrevPathTypeUpdate
} from "../../../stores/useStore";
import {propsType} from './Cashpick1';

export default function NplaceQuiz(props: propsType) {
    const {mediaCode,campaignCode,campaignID,payload,uk,adFallBack} = props;

    const setUserData = usePlaceUserStore(state => state.setUserData)
    const userInfo = usePlaceUserStore()

    const data = useStatePair<PlacePresentationValueObject | null>(null)
    const isLoading = useStatePair<boolean>(true)

    const currentPage = useCurrentPage()
    const nextPage = useNextPage()
    const expirationDate = useGuideExpirationDate()
    const updateExpirationDate = useHiddenGuideListUpdate()
    const hiddenGuideList = useHiddenGuideList()
    const updateHiddenGuideList = useHiddenGuideListUpdate()
    const prevPathType = usePrevPathType()
    const updatePrevPathType = usePrevPathTypeUpdate()

    const updateCurrentPage = useCurrentPageUpdate()
    const updateNextPage = useNextPageUpdate()

    const getMission = async () => {
        const missionExternalId = uk || ''
        try {
            isLoading.setValue(true)
            const v = await PlaceIO.getPlacePresentationForUser(missionExternalId,10,true,userInfo.placePathJointId,campaignCode,userInfo.attractionId)
            console.log("page rendering")
            console.log(v)
            data.setValue(v)
            if(v) {
                setUserData(v.userId.toString(), v.placePathJointId.toString(),window.location.href, getFormattedDateString(new Date()), v.placeAttractionId?.toString() || null )
                setCurrentPage(v,hiddenGuideList,currentPage,nextPage,updateCurrentPage,updateNextPage,updateHiddenGuideList,updatePrevPathType,prevPathType,v.pathType ?? 0)
            }
        } catch(e : any) {
            console.error(e)
            let ErrorString = e.toString()
            data.setValue(null)
            configurePlaceErrorTypeAndSetErrorPage(ErrorString, window.location.href ,updateCurrentPage)
        } finally {
            isLoading.setValue(false)
        }
    }

    const browserReload = async () => {
        const missionExternalId = uk || ''
        try {
            isLoading.setValue(true)
            const v = await PlaceIO.getPlacePresentationForUser(missionExternalId,10,false,null,campaignCode,null)
            console.log("browser reload")
            console.log(v)
            data.setValue(v)
            if(v) {
                setUserData(v.userId.toString(), v.placePathJointId.toString(), window.location.href, getFormattedDateString(new Date()), v.placeAttractionId?.toString() || null )
                setCurrentPage(v,hiddenGuideList,currentPage,nextPage,updateCurrentPage,updateNextPage,updateHiddenGuideList,updatePrevPathType,prevPathType,v.pathType ?? 0)
            }
        } catch(e : any) {
            console.error(e)
            let ErrorString = e.toString()
            data.setValue(null)
            configurePlaceErrorTypeAndSetErrorPage(ErrorString, window.location.href, updateCurrentPage)
        } finally {
            isLoading.setValue(false)
        }
    }

    const otherMissionBtnClick = () => {
        browserReload()
            .then(()=>{
                {
                    if (data.value) {
                        PlacePathJointEventIO.post({
                            placePathJointId: data.value.placePathJointId,
                            userId: data.value.userId,
                            misc: payload,
                            eventType: PlaceEventType.PlaceAnotherMissionClick
                        }).then(
                            v => {
                                console.log(v)
                            }
                        ).catch(e => console.error(e))
                    }
                }
            })
            .catch(e=>console.error(e))
    }

    useEffect(() => {
        console.log(userInfo)
        if(userInfo.placePathJointId == null || currentPage == 'ErrorPage') otherMissionBtnClick();
        else getMission()
        checkGuideVisible(expirationDate,updateExpirationDate)
    }, [uk])

    useEffect(() => {
        if (data.value) {
            PlacePathJointEventIO.post({
                placePathJointId:data.value.placePathJointId,
                userId:data.value.userId,
                misc:payload,
                eventType:PlaceEventType.PlaceMissionEntryPageLanding
            }).then(
                v=>console.log(v)
            ).catch(e=>console.error(e))
        }
    }, [data.value])

    if(isLoading.value){
        return  <Spinner />
    }
    else{
            if (currentPage === 'ExhaustedPage') {
                return <ExhaustedPage />
            }
            if (currentPage === 'ErrorPage') {
                return <ErrorPage />
            }
            if(currentPage === 'ParticipationCntFullPage') {
                return <ParticipationCntFullPage/>
            }
            if(currentPage === 'ThresholdPage') {
                return <ThresholdPage/>
            }
            if(currentPage === 'GuideLine'){
                return <GuideLine data={data.value} primaryColor={resolvePlacePathType(data.value?.pathType,PlacePathTypeColor)}/>
            }
            if(currentPage === 'Mission'){
                return <Mission otherMissionBtnClick={otherMissionBtnClick} mediaId={payload} mediaCode={mediaCode} data={data.value} isLoading={isLoading.value} primaryColor={resolvePlacePathType(data.value?.pathType,PlacePathTypeColor)}/>
            }
    }

    return (
        <Mission otherMissionBtnClick={otherMissionBtnClick} mediaId={payload} mediaCode={mediaCode} data={data.value} isLoading={isLoading.value} primaryColor={resolvePlacePathType(data.value?.pathType,PlacePathTypeColor)}/>
    );
}